import { useQuery } from '@tanstack/react-query'
import { api, ApiError, type Me } from './api'

// The signed-in person, or null when signed out.
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api<Me>('/me')
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null
        throw e
      }
    },
  })
}
